import { ImageTextBlockProps } from '~/components/ImageTextBlock/models';
import { pageBlockUIMapper } from '~/mappers/pageBlock';

import { ImageTextBlock } from './models';

export const imageTextBlockMapper = ({
  pageBlockUI: [pageBlockUI],
  componentId,
  items,
  currentPageUid,
}: ImageTextBlock): ImageTextBlockProps => ({
  pageBlock: pageBlockUIMapper(pageBlockUI.ui),
  componentId,
  items: items.map((item) =>
    Object.entries(item)
      .filter(([, value]) => Boolean(value))
      .reduce(
        (result, [key, { typeName, ...rest }]) => ({
          ...result,
          [key]: { typeName, item: rest },
        }),
        {}
      )
  ),
  currentPageUid,
});
